import { faBackward, faFileAlt } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Grid, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ServiceContext } from "../../Contexts/ServiceContext/ServiceContext";
import { useLoading } from "../../Hooks/useLoading";
import { IDocumentDetail } from "../../Interfaces/IDocumentDetail";
import { IDocumentRecord } from "../../Interfaces/IDocumentRecord";
import { GLOBALS } from "../../Models/Globals";
import { NoRecordsMessage } from "../NoRecordsMessage/NoRecordsMessage";
import { HeaderTableCell } from "../Styled/HeaderTableCell";
import { TableDocsDetail } from "../TableDocsDetail/TableDocsDetail";
import { ISecDocDetailRenderProps } from "./ISecDocDetailRenderProps";




export const SecDocDetailRender = ({

    docs,
    docType,
    OnBack

}: ISecDocDetailRenderProps) => {


    const { SrvContext } = useContext(ServiceContext);
    const [records, setRecords] = useState<IDocumentDetail[]>(docs);
    const { t, i18n } = useTranslation();
    const [isLoading, setIsLoading] = useLoading();
    const [aditional10KDocsA1, setAditional10KDocsA1] = useState<IDocumentRecord[]>([]);
    const [aditional10KDocsA2, setAditional10KDocsA2] = useState<IDocumentRecord[]>([]);


    const Load10KAditionalDocuments = async () => {

        if (records.length > 0) {

            const doc = records[0];

            console.info("document", doc);

            const yearToQuery = moment(
                doc.fecha_publicacion_hijo == null ?
                    doc.fecha_publicacion_padre :
                    doc.fecha_publicacion_hijo
            ).year();

            const adendumsA1 = await SrvContext.GetDocumentsByTypeYear(
                GLOBALS.ID_10K_ADDITIONAL_DOCS_1,
                SrvContext.WindowData.sccoDocsRender.idiomaCodeId,
                yearToQuery
            );

            setAditional10KDocsA1(adendumsA1);

            const adendumsA2 = await SrvContext.GetDocumentsByTypeYear(
                GLOBALS.ID_10K_ADDITIONAL_DOCS_2,
                SrvContext.WindowData.sccoDocsRender.idiomaCodeId,
                yearToQuery
            );

            setAditional10KDocsA2(adendumsA2);

            setIsLoading(false);

        }

    };


    const formatFechas = (fechaHijo: string, fechaPadre: string) => {

        const formated = moment(fechaHijo == null ? fechaPadre : fechaHijo);

        if (formated.isValid()) {

            return (
                <>
                    {formated.format(GLOBALS.DATE_FORMAT)}
                </>
            )

        }


        return (
            <>
                -
            </>
        )



    }


    useEffect(() => {

        if (docType == GLOBALS.DOC_TYPE_10K) {

            Load10KAditionalDocuments();

        }

    }, []);


    return (
        <Grid container alignItems="center" spacing={3}>
            <Grid item xs={12} container justifyContent="center">
                <Grid item xs={12} md={8}>
                    {
                        records.length > 0 ? (
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 700 }}>
                                    <TableHead>
                                        <TableRow>
                                            <HeaderTableCell align="center">{t('label-file-name')}</HeaderTableCell>
                                            <HeaderTableCell align="center">{t('label-description')}</HeaderTableCell>
                                            <HeaderTableCell align="center">{t('label-publish-date')}</HeaderTableCell>
                                            <HeaderTableCell align="center">{t('label-last-update')}</HeaderTableCell>
                                            <HeaderTableCell align="center">{t('label-file-size')}</HeaderTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            records.map((doc, index) => (
                                                <TableRow>
                                                    <TableCell align="center">
                                                        <Button href={doc.url_hijo == "null" ? doc.url_padre : doc.url_hijo} download target="_blank">
                                                            <Typography variant="body1">
                                                                <FontAwesomeIcon icon={faFileAlt} /> {
                                                                    doc.nombre_documento_hijo == "null" ?
                                                                        doc.nombre_documento_padre :
                                                                        doc.nombre_documento_hijo
                                                                }
                                                            </Typography>
                                                        </Button>
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {
                                                            doc.descripcion_hijo == "null" ?
                                                                doc.descripcion_padre : doc.descripcion_hijo
                                                        }
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {
                                                            formatFechas(doc.fecha_publicacion_hijo, doc.fecha_publicacion_padre)
                                                        }
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {
                                                            formatFechas(doc.fecha_actualizacion_hijo, doc.fecha_actualizacion_padre)
                                                        }
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {
                                                            doc.peso_hijo == "null" ?
                                                                doc.peso_padre :
                                                                doc.peso_hijo
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        ) : (
                            <NoRecordsMessage />
                        )
                    }
                </Grid>
                {
                    docType == GLOBALS.DOC_TYPE_10K &&
                    <Grid item xs={12} md={8} container>
                        {
                            isLoading ? (
                                <Grid item xs={12}>
                                    <LinearProgress />
                                </Grid>
                            ) : (
                                <>
                                    <TableDocsDetail
                                        Title="FORM 10K-A Amendment 1"
                                        Records={aditional10KDocsA1}
                                    />
                                    <TableDocsDetail
                                        Title="FORM 10K-A Amendment 2"
                                        Records={aditional10KDocsA2}
                                    />
                                </>
                            )
                        }
                    </Grid>
                }
            </Grid>
            <Grid item xs={12} container justifyContent="center">
                <Grid item xs={12} md={6} sx={{ marginTop: "1rem" }}>
                    <Button variant="contained" onClick={OnBack}>
                        <Typography variant="body1">
                            <FontAwesomeIcon icon={faBackward} /> {t('label-regresar')}
                        </Typography>
                    </Button>
                </Grid>
            </Grid>
        </Grid>

    );

};